// config.js
const baseUrl = "https://layoutxmw-api.xmicrowave.com";
//const baseUrl = "http://192.168.10.35:3333";
const baseApiUrl = `${baseUrl}/api/v1`;
const apiUrl = `${baseApiUrl}/categorytables`;
const pnUrl = `${baseApiUrl}/parts`;
const ffUrl = `${baseApiUrl}/formfactors`;
const errorUrl = `${baseApiUrl}/errors/report`;
const partsTableUrl = `${baseApiUrl}/parts/table`;
const newHeader = `${baseApiUrl}/groups`;
const currentImgs = "https://catalog.quanticxmw.com/";
const assetURL = "https://layoutxmw-assets.xmicrowave.com/cascade";
const uploadTitleBlockURL =
  "https://layoutxmw-assets.s3.us-west-2.amazonaws.com/";

const generateTitleBlockURL = `${baseApiUrl}/generate/pdf/image`;
const generatePDF = `${baseApiUrl}/generate/pdf`;

export {
  baseUrl,
  baseApiUrl,
  apiUrl,
  pnUrl,
  ffUrl,
  errorUrl,
  partsTableUrl,
  newHeader,
  currentImgs,
  assetURL,
  generateTitleBlockURL,
  uploadTitleBlockURL,
  generatePDF,
};
